const SDK_VERSION = '7.58.1';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
